import Vue from '../consts/vue'
import Datepicker from 'vuejs-datepicker'

Vue.component('Datepicker', Datepicker)
